export default {"src":"/_next/static/media/bestPrice.f5e330c9.svg","height":69,"width":69,"blurWidth":0,"blurHeight":0};